module.exports = __webpack_public_path__ + "img/medical-rays-x.220eb5dd.svg";